/**
 * Google Play listing for the Stoat app
 */
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=chat.revolt";
